import * as selectors from './AlertsListPage/selectors'
import * as actions from './actions'
import AlertsPageHandler, { EventProps, ExternalProps, Props } from './AlertsPageHandler'
import { AppState, Dispatch } from '../../types'
import { connect } from 'react-redux'

const mapProps = (state: AppState, ownProps: ExternalProps): Props => ({
  ...ownProps,
  hasAlerts: selectors.getAlerts(state).length > 0,
  loadingAlerts: selectors.isLoading(state),
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  fetchAlertsMeta: () => dispatch(actions.fetchAlertsMeta())
})

export default connect(mapProps, mapDispatch)(AlertsPageHandler)
